import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useNavigate } from "react-router-dom";
import SideModal from '/src/components/modal/SideModal/SideModal'
import useModalHelper from "/src/components/modal/hooks/useModalHelper";

import ChannelWeb from "./ChannelWeb/ChannelWeb"
import ChannelTelephony from "./ChannelTelephony/ChannelTelephony"


import "./ChannelModal.css"
import "/src/assets/css/polices.css";

const ChannelModal = NiceModal.create(({ title, data }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    //const form = { id: data == undefined? null : data.id,nameDataset: nameDataset,label:  data == undefined? null : data.label, title: title, feeling: data == undefined? null : data.feeling, statementArray : data == undefined? [] : data.statements, replyArray : data == undefined? [] : data.responses}

    const isWebMode = ()=>{
        return data.type.name == "web"
    }

    return (
        <SideModal name="change-password channel_web_overflow_hidden" id={modal.id} autoClose="true" onClose={onClose}>
            <div>
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({idIconModal:"close_modal_container"})}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            {
                isWebMode() ? 

                <ChannelWeb channel={data} modal={ {resolve: modal.resolve ,onClose: onClose}}></ChannelWeb>
                : 
                <ChannelTelephony data={data} modal={ {resolve: modal.resolve ,onClose: onClose}}></ChannelTelephony>
            }

        </SideModal >
    )
});

export default ChannelModal;